// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FreeShippingBanner_wrapper__2s5Kv","inDesktop":"FreeShippingBanner_inDesktop__2H-VK"};